import React from "react";
import { Card, Image } from "semantic-ui-react";
import Radium from "radium";

const styles = {
	cardContainer: {
		display: "flex",
		justifyContent: "center",
		alignItems: "stretch",  // Ensure both cards stretch to the same height
	},
	card: {
		flex: "1",
		margin: "10px",
		minWidth: "250px",
		display: "flex",
		flexDirection: "column",
	},
	content: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		flexWrap: "wrap",
		flex: "1",  // Ensure the content fills the card
	},
	selectPhoto: {
		cursor: "pointer",
		padding: 0,
		":hover": {
			backgroundColor: "rgba(0,0,0,0.1)",
		},
	},
	cardSelect: {
		":hover": {
			backgroundColor: "rgba(0,0,0,0.1)",
		},
	},
};

const PhotoForm = ({ element }) => (
	<div style={styles.cardContainer}>
		<Card style={{ ...styles.card, ...styles.cardSelect }}>
			<Card.Content style={styles.content}>
				{element.picto ? (
					<Image style={{ marginBottom: "1em" }} size="tiny" src={`${process.env.REACT_APP_BASE_URL}/tubePictos/${element.picto.filename}`} />
				) : (
					<Image
						style={{ marginBottom: "1em" }}
						size="tiny"
						src={`${process.env.REACT_APP_BASE_URL}/tubePictos/${process.env.REACT_APP_TUBE_PIC_FILENAME}`}
					/>
				)}
				<Card.Header style={{ width: "100%", textAlign: "center" }}>{element.code}</Card.Header>
				<Card.Meta>{element.label}</Card.Meta>
			</Card.Content>
		</Card>

		<Card style={{ ...styles.card, ...styles.cardSelect }}>
			<Card.Content style={styles.content}>
				<div style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: "1" }}>
					<svg width="100" height="100">
						<circle cx="50" cy="50" r="37.5" strokeWidth={7} stroke={`${element.color_crown || "#FFFFFF"}`} fill={`${element.color}`} />
					</svg>
					<div style={{ textAlign: "center", flex: "1" }}>
						{element.color_crown && (
							<p style={{ color: `${element.color_crown}` }}>Couleur de la couronne</p>
						)}
						<p style={{ color: `${element.color}` }}>Couleur du capuchon</p>
					</div>
				</div>
			</Card.Content>
		</Card>
	</div>
);

export default Radium(PhotoForm);